import BaseComponent from '../../base/base_component';
import _ from '../../utils/underscore';
import Device from '../../utils/device/device';
import Event from '../../utils/event';
import {SYSTEM_EVENTS} from '../../events/events';
import {PRIORITY_LEVEL} from '../../services/overlay_manager/overlay_manager_levels';
import {TYPES} from '../../services/overlay_manager/overlay_manager_types';
import DOM from '../../utils/dom';

let gameWindowHtml = require('./view/game_window.html');
const GAME_OPEN_CLASS = 'cgp-game-open';


export default class GameWindowComponentController extends BaseComponent {
    static CLASS = 'GameWindowComponentController';

    private _gameBody;
    private _isGamePlayed = false;
    private _isReal: boolean;
    private _gameType: number;
    private _gameSize;
    private _isResizable: boolean;
    private _gameBackgroundImage: string;
    private _showResponsibleGamingIcons: boolean;

    init(params) {
        super.init(params);

        params = params || {};

        if(!params.gameType) {
            this.throwError('32',`${this.getClassName()} expects parameter gameType which was not supplied`, {params});
        }

        if(_.isNullOrUndefined(params.isReal)) {
            this.throwError('36',`${this.getClassName()} expects parameter isReal which was not supplied`, {params});
        }

        if(!params.gameBody) {
            this.throwError('40',`${this.getClassName()} expects parameter gameBody which was not supplied`, {params});
        }

        this._isReal = params.isReal;
        this._gameType = params.gameType;
        this._gameSize = params.gameSize;
        this._isResizable = params.isResizable;
        this._gameBackgroundImage = params.gameBackgroundImage;
        this._showResponsibleGamingIcons = this.serviceFactory.regulationService().getRegulation().showResponsibleIcons();

        this.setInnerHtml(this.bake(gameWindowHtml, {
            noRegulationIconsClass: !this._showResponsibleGamingIcons ? "no-regulation-icons": ""
        }));

        this._setWindowBackground();
        this._addGameWindowSpecificClasses();

        this._appendNavigationBar(params.navigationBar);

        this._appendRegulationStripe(params.regulationStripe);

        this._appendGameBody(params.gameBody);


        this._subscribe();
    }

    private _subscribe() {
        this.onSystemEvent(SYSTEM_EVENTS.BALANCE_UPDATED, () => {
            this._isGamePlayed = true;
        });

        this.onSystemEvent(SYSTEM_EVENTS.CLOSE_ALL_OVERLAY, () => {
            this.closeGameWindow();
        });
    }

    private _appendRegulationStripe(regulationStrip) {
        if (!regulationStrip) {
            return;
        }
        if (regulationStrip.closeFnc) {
            regulationStrip.closeFnc(() => this.closeGameWindow());
        }
        this.appendChildComponent(regulationStrip, '.cgp-game-window-regulation-strip');
    }

    private _getCgpGameModeClass() {
        if(this._isReal) {
            return 'cgp-game-real';
        } else {
            return 'cgp-game-anonymous';
        }
    }

    private static _getCgpMobileClass() {
        if (Device.os.isMobileOS) {
            return 'cgp-game-mobile';
        }
        else {
            return 'cgp-game-mobile-not';
        }
    }


    private _getCgpNotResizableClass(){
        if (this._isResizable) {
            return 'cgp-game-resizable';
        }
        else {
            return 'cgp-game-not-resizable';
        }
    }


    private _appendNavigationBar(navigationBar) {
        if(navigationBar) {
            this.appendChildComponent(navigationBar, '.cgp-game-window-navigation-panel');
            navigationBar.registerOnCloseCallback(() => this.closeGameWindow({
                showNextGameSuggestion: true
            }));
        }
    }


    private _appendGameBody(gameBody) {
        this._gameBody = gameBody;
        this.appendChildComponent(gameBody, '.cgp-game-window-content-body');
    }


    private _addGameWindowSpecificClasses() {
        this.addClass('cy-game-window');
        this.addClass('cgp-game-window');
        this.addClass(GameWindowComponentController._getCgpMobileClass());
        this.addClass(this._getCgpGameModeClass());
        this.addClass(this._getCgpNotResizableClass());
    }


    private _setWindowBackground() {
        // no background is required for MOBILE backgrounds
        if (Device.os.isMobileOS) {
            return;
        }

        this.serviceFactory.gameService().loadGameBackground(this._gameBackgroundImage)
            .then(backgroundImg => {
                this.getEl().style.backgroundImage = "url('" + backgroundImg.backgroundUrl + "')";
            });
    }


    private _shouldDisplayMdpLowResolutionMessage() {
        if (Device.isMobile()) {
            return false;
        }

        if (_.isFullScreen()) {
            return false;
        }


        if (this._isResizable) {
            return false;
        }


        let gameWindowContentBodyComputedSize = this._getGameWindowContentBodyComputedSize();

        return !(this._gameSize.height < gameWindowContentBodyComputedSize.height
            && this._gameSize.width < gameWindowContentBodyComputedSize.width);
    }

    private _getGameWindowContentBodyComputedSize() {
        const cgpGameWindowContentBody = this.querySelector('.cgp-game-window-content-body');

        return this.serviceFactory.windowService().getComputedSize(cgpGameWindowContentBody);
    }

    private _showMdpLowResolutionMessage() {

        if (!this._shouldDisplayMdpLowResolutionMessage()) {
            return;
        }

        let languageService = this.serviceFactory.languageService();
        // Fire event to open overlay that the game will be contain in.
        Event.fire(SYSTEM_EVENTS.MESSAGE_OPEN, {
            text: languageService.translation('mdp_low_resolution_game_message_content'),
            buttons: [
                {
                    name: languageService.translation('mdp_low_resolution_game_message_allow_full_screen'),
                    callback: () => {
                        _.openFullScreen();
                    }
                },
                {
                    name: languageService.translation('mdp_low_resolution_game_message_close'),
                    callback: () => {}
                }
            ]
        });
    }

    private _showGameWindowInOverlay() {
        let additionalClasses = ['cgp-overlay-gamewindow'];
        let contentClasses = [];

        if (!Device.isMobile()) {
            if (this._isReal) {
                contentClasses.push('cgp-property-gameframe-real-size');
                additionalClasses.push('cgp-property-gameframe-real-horizontal-position');
            } else {
                contentClasses.push('cgp-property-gameframe-anon-size');
                additionalClasses.push('cgp-property-gameframe-anon-horizontal-position');
            }
        }

        if (Device.os.isMobileOS) {
            this.toggleGameOpenClass(true);
        }

        Event.fire(SYSTEM_EVENTS.OPEN_OVERLAY, {
            el: this.getEl(),
            additionalClasses: additionalClasses,
            contentAdditionalClasses: contentClasses,
            type: TYPES.FULL_SCREEN,
            isCloseBtnAllowed: false,
            isCloseByEscape: true,
            priority: PRIORITY_LEVEL.GAME_FRAME
        });

        this.onAppendedToDOM();
    }


    private _isVisible = false;

    get isVisible() {
        return this._isVisible;
    }

    show() {
        this.serviceFactory.gameService().closeRunningGame();

        this._showGameWindowInOverlay();
        this._isVisible = true;
        // _showMdpLowResolutionMessage must be after _showGameWindowInOverlay
        // otherwise _getGameWindowContentBodyComputedSize will not work correctly because
        // serviceFactory.windowService().getComputedSize() will return 0 because the element would not be in the DOM
        this._showMdpLowResolutionMessage();



        return "";
    }

    closeGameWindow(options: any = {}) {
        options = {showNextGameSuggestion: false, ...options};
        this.shutDown();

        if (Device.os.isMobileOS) {
            this.toggleGameOpenClass(false);
        }

        Event.fire(SYSTEM_EVENTS.CLOSE_OVERLAY, {priority: PRIORITY_LEVEL.GAME_FRAME});
        Event.fire(SYSTEM_EVENTS.CLOSE_GAME, {
            gameType: this._gameType,
            isReal: this._isReal,
            isGamePlayed: this._isGamePlayed,
            showNextGameSuggestion: options.showNextGameSuggestion
        });

        this._isVisible = false;
    }

    /***
     * @description Add cgp-game-open class to the body tag
     *
     */
    toggleGameOpenClass(toAdd = false){
        if(toAdd){
            DOM.addClass(DOM.getBody(), GAME_OPEN_CLASS);
        }
        else{
            DOM.removeClass(DOM.getBody(), GAME_OPEN_CLASS);
        }
    }
}
